import { useMemo } from 'react';
import { resolveUiLocale } from './locale.js';
import { translate, translateDuration } from './messages.js';

export function useI18n() {
  const locale = useMemo(() => resolveUiLocale(), []);
  return useMemo(() => ({
    locale,
    t: (key, vars) => translate(locale, key, vars),
    duration: (label) => translateDuration(locale, label)
  }), [locale]);
}
